// Brighter Land International School (BLIS) - Official Prospectus & Institutional Records

export const schoolAccountDetails = {
  bankName: "First Bank",
  accountName: "Brighter Land International School",
  accountNumber: "2043561832",
  session: "2026/2027 Academic Session",
  motto: "Study to Make Impact",
  tagline: "Where Education Meets Purpose",
  scripture: "Train up a child in the way he should go… — Proverbs 22:6",
  mission: "To provide quality, faith-based education and compassionate scholarships that nurture children—especially orphans, missionary children, and the vulnerable—into responsible, confident, and impactful global leaders.",
  vision: "To be a premier Christian institution where education meets purpose, raising a generation of godly, intellectually formidable, and purpose-driven leaders who transform society.",
  mandate: "To provide quality education and nurture children—especially orphans, missionary children, children from conflict-affected communities, and the less privileged—into responsible, confident and impactful leaders.",
  pillars: [
    { title: "Building Minds", desc: "World-class foundational curriculum from Crèche to Senior Secondary." },
    { title: "Shaping Character", desc: "Solid faith-based moral discipline, integrity, and godly virtue." },
    { title: "Discovering Purpose", desc: "Unlocking God-given potential through personalized mentorship." },
    { title: "Preparing Future Leaders", desc: "Raising confident, responsible, and impactful societal change-makers." },
  ],
  logo: "/images/logo.png",
  proprietor: "Rev. Fidelis Gambo",
  proprietorTitle: "Proprietor & Founder (Police Chaplain & Lectured at Theological Seminary)",
  proprietress: "Mrs. Sifon Gambo",
  proprietressTitle: "Proprietress & Co-Founder (Dedicated Educator & Pastoral Care Director)",
  email: "brighterlandschool2022@gmail.com",
  phone: "+234 803 436 7951",
  address: "Gura-Suga, Opposite Police Staff College, Jos, Plateau State, Nigeria",
}

export const prospectusData = [
  {
    level: "CRÈCHE",
    code: "creche",
    ageGroup: "Infants & Toddlers",
    sectionA: {
      title: "Section A: Tuition & Levies (Payable to School)",
      items: [
        { name: "Tuition Fees", amount: 14000 },
        { name: "PTA Levy", amount: 1000 },
        { name: "Development Levy", amount: 1000 },
        { name: "Examination Fee", amount: 1000 },
        { name: "First Aid", amount: 500 },
        { name: "Lesson Fee", amount: 2000 },
      ],
      total: 19500,
    },
    sectionB: {
      title: "Section B: Uniforms & Learning Materials (For Students)",
      items: [
        { name: "School Uniform", amount: 8000 },
        { name: "Sweater", amount: 10000 },
        { name: "Wednesday Wear", amount: 7000 },
        { name: "Sportswear", amount: 14000 },
        { name: "Books", amount: 8500 },
      ],
      total: 47500,
    },
    additionalRequirements: "2 rolls of tissue paper and 1 medium-size detergent",
    grandTotal: 67000,
  },
  {
    level: "NURSERY ONE & TWO",
    code: "nursery",
    ageGroup: "Nursery 1 & Nursery 2",
    sectionA: {
      title: "Section A: Tuition & Levies (Payable to School)",
      items: [
        { name: "Tuition Fees", amount: 14000 },
        { name: "PTA Levy", amount: 1000 },
        { name: "Development Levy", amount: 1000 },
        { name: "Examination Fee", amount: 1000 },
        { name: "First Aid", amount: 500 },
        { name: "Lesson Fee", amount: 2000 },
      ],
      total: 19500,
    },
    sectionB: {
      title: "Section B: Uniforms & Learning Materials (For Students)",
      items: [
        { name: "School Uniform", amount: 8000 },
        { name: "Sweater", amount: 10000 },
        { name: "Wednesday Wear", amount: 7000 },
        { name: "Sportswear", amount: 14000 },
        { name: "Books", amount: 11000 },
      ],
      total: 50000,
    },
    additionalRequirements: "2 rolls of tissue paper and 1 medium-size detergent",
    grandTotal: 69500,
  },
  {
    level: "PRIMARY ONE – FIVE",
    code: "primary",
    ageGroup: "Primary 1 to Primary 5",
    sectionA: {
      title: "Section A: Tuition & Levies (Payable to School)",
      items: [
        { name: "Tuition Fees", amount: 15000 },
        { name: "PTA Levy", amount: 1000 },
        { name: "Development Levy", amount: 1000 },
        { name: "Examination Fee", amount: 2000 },
        { name: "First Aid", amount: 1000 },
        { name: "Lesson Fee", amount: 2000 },
      ],
      total: 22000,
    },
    sectionB: {
      title: "Section B: Uniforms & Learning Materials (For Students)",
      items: [
        { name: "School Uniform", amount: 14000 },
        { name: "Sweater", amount: 10000 },
        { name: "Wednesday Wear", amount: 7000 },
        { name: "Sportswear", amount: 14000 },
        { name: "Books (Primary 1 - 3: ₦14,000 / Primary 4 - 5: ₦15,000)", amount: 14000 },
      ],
      total: 59000,
    },
    additionalRequirements: "2 rolls of tissue paper and 1 medium-size detergent",
    grandTotal: 81000,
    bookNote: "Books: Primary 1 – ₦14,000 | Primary 2 – ₦14,000 | Primary 3 – ₦14,000 | Primary 4 – ₦15,000 | Primary 5 – ₦15,000",
  },
  {
    level: "SECONDARY SCHOOL – JUNIOR (JSS 1–3)",
    code: "jss",
    ageGroup: "JSS 1, JSS 2, & JSS 3",
    sectionA: {
      title: "Section A: Tuition & Levies (Payable to School)",
      items: [
        { name: "Tuition Fees", amount: 23000 },
        { name: "Examination Fee", amount: 2000 },
        { name: "Lesson Fee", amount: 2000 },
        { name: "Development Levy", amount: 1000 },
        { name: "PTA Levy", amount: 1000 },
        { name: "First Aid", amount: 1000 },
      ],
      total: 30000,
    },
    sectionB: {
      title: "Section B: Uniforms & Learning Materials (For Students)",
      items: [
        { name: "School Uniform (2 sets)", amount: 20000 },
        { name: "Sweater", amount: 10000 },
        { name: "Sportswear", amount: 14000 },
        { name: "Books (JSS 1: ₦20,000 / JSS 2-3: ₦16,500)", amount: 20000 },
      ],
      total: 64000,
    },
    additionalRequirements: "1 big mop stick or 1 big hoe or 2 big bunches of brooms",
    grandTotal: 94000,
    bookNote: "Books: JSS 1 – ₦20,000 | JSS 2 – ₦16,500 | JSS 3 – ₦16,500",
  },
  {
    level: "SECONDARY SCHOOL – SENIOR (SS 1–3)",
    code: "sss",
    ageGroup: "SS 1, SS 2, & SS 3",
    sectionA: {
      title: "Section A: Tuition & Levies (Payable to School)",
      items: [
        { name: "Tuition Fees", amount: 23000 },
        { name: "Examination Fee", amount: 2000 },
        { name: "Lesson Fee", amount: 2000 },
        { name: "Development Levy", amount: 1000 },
        { name: "PTA Levy", amount: 1000 },
        { name: "First Aid", amount: 1000 },
      ],
      total: 30000,
    },
    sectionB: {
      title: "Section B: Uniforms & Learning Materials (For Students)",
      items: [
        { name: "School Uniform (2 sets)", amount: 20000 },
        { name: "Sweater", amount: 10000 },
        { name: "Sportswear", amount: 14000 },
        { name: "Books", amount: 32000 },
      ],
      total: 76000,
    },
    additionalRequirements: "1 big mop stick or 1 big hoe or 2 big bunches of brooms",
    grandTotal: 106000,
    bookNote: "Books: SS 1 – SS 3 – ₦32,000 comprehensive package",
  },
]

export const getProspectusForGrade = (gradeName) => {
  if (!gradeName) return prospectusData[1]
  const g = gradeName.toLowerCase().trim()
  if (g.includes("crèche") || g.includes("creche") || g.includes("toddler") || g.includes("infant")) {
    return prospectusData[0] // CRÈCHE (Section A: ₦19,500, Section B: ₦47,500, Grand Total: ₦67,000)
  }
  if (g.includes("nursery") || g.includes("kg") || g.includes("kindergarten")) {
    return prospectusData[1] // NURSERY ONE & TWO (Section A: ₦19,500, Section B: ₦50,000, Grand Total: ₦69,500)
  }
  if (g.includes("primary") || g.includes("basic") || g.includes("pry")) {
    return prospectusData[2] // PRIMARY ONE – FIVE (Section A: ₦22,000, Section B: ₦59,000, Grand Total: ₦81,000)
  }
  if (g.includes("jss") || g.includes("junior")) {
    return prospectusData[3] // SECONDARY SCHOOL – JUNIOR (JSS 1–3) (Section A: ₦30,000, Section B: ₦64,000, Grand Total: ₦94,000)
  }
  if (g.includes("ss") || g.includes("senior")) {
    return prospectusData[4] // SECONDARY SCHOOL – SENIOR (SS 1–3) (Section A: ₦30,000, Section B: ₦76,000, Grand Total: ₦106,000)
  }
  return prospectusData[1]
}

export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Holistic Moral & Academic Distinction",
    desc: "Dedicated to intellectual excellence, strong moral grounding, and character molding from Crèche through Senior Secondary School.",
  },
  {
    id: 2,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Outstanding Board Examination Track Record",
    desc: "Proven excellence in Common Entrance, Basic Education Certificate Examination (BECE), WAEC, NECO, NABTEB, and JAMB UTME.",
  },
  {
    id: 3,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Practical ICT, Science & Sports Development",
    desc: "Modern computing suites, dedicated science and basic technology learning resources, Wednesday wear culture, and active sports development.",
  },
]

export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "300+",
    title: "SCHOLARS ENROLLED",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "35+",
    title: "EXPERIENCED EDUCATORS",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/diploma.png",
    data: "58+",
    title: "GRADUATED STUDENTS",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "4+",
    title: "YEARS OF OPERATION",
  },
]

export const coursesCard = [
  {
    id: 1,
    icon: "fas fa-baby",
    coursesName: "Crèche & Early Childcare Division",
    stage: "Early Foundation Stage",
    targetAge: "3 Months – 2 Years",
    summary: "Gentle, secure, and nurturing infant care focusing on early sensory stimulation, emotional bonding, and phonics readiness in a hygienic setting.",
    highlights: [
      "Individualized feeding & hygienic rest schedules",
      "Sensory motor exploration & auditory stimulation",
      "Gentle speech development & phonemic awareness",
    ],
    leader: "Alheri Maga (Head Teacher) & Early Care Team",
    distinctive: "Tender Care & Hygiene Certified",
    courTeacher: [
      {
        dcover: "./images/team/t2.webp",
        name: "Alheri Maga (Head Teacher)",
        totalTime: "Early Childhood Care Specialists",
      },
    ],
  },
  {
    id: 2,
    icon: "fas fa-shapes",
    coursesName: "Nursery School (Nursery 1 & 2)",
    stage: "NERDC Early Years Framework",
    targetAge: "Ages 3 – 5 Years",
    summary: "Foundational early education centered on Jolly Phonics sound blending, early numeracy, social courtesy, and creative expression.",
    highlights: [
      "Jolly Phonics 42-sound reading system",
      "Concrete number sense, counting & patterns",
      "Creative art, nursery rhymes & sensory coordination",
    ],
    leader: "Shut Esther (Assistant Head Mistress)",
    distinctive: "Jolly Phonics Certified",
    courTeacher: [
      {
        dcover: "./images/team/Shut Esther.jpeg",
        name: "Shut Esther (Assistant HM)",
        totalTime: "Early Childhood Lead Educator",
      },
    ],
  },
  {
    id: 3,
    icon: "fas fa-book-reader",
    coursesName: "Primary School (Basic 1 – 5)",
    stage: "Universal Basic Education (UBE)",
    targetAge: "Ages 6 – 11 Years",
    summary: "Rigorous foundational learning across core literacy, mathematics, basic science & technology, digital literacy, and citizenship.",
    highlights: [
      "Intensive National Common Entrance preparation",
      "Basic Science, Technology & practical reasoning",
      "Hands-on digital studies & keyboarding literacy",
    ],
    leader: "Alheri Maga (Head Teacher & V.P Admin)",
    distinctive: "Outstanding Common Entrance Success",
    courTeacher: [
      {
        dcover: "./images/team/t2.webp",
        name: "Alheri Maga (Head Teacher)",
        totalTime: "Head of Basic Education",
      },
    ],
  },
  {
    id: 4,
    icon: "fas fa-graduation-cap",
    coursesName: "Junior Secondary School (JSS 1 – 3)",
    stage: "Lower Secondary & BECE Center",
    targetAge: "Ages 11 – 14 Years",
    summary: "Pre-vocational, scientific, and business grounding preparing junior scholars for the Basic Education Certificate Examination (BECE).",
    highlights: [
      "Intermediate Science & digital problem solving",
      "Business Studies, clerical practice & entrepreneurship",
      "Official accredited BECE examination training",
    ],
    leader: "Tangai Gamaliel Samuel (Principal)",
    distinctive: "BECE Distinction Center",
    courTeacher: [
      {
        dcover: "./images/team/gamaliel.jpeg",
        name: "Tangai Gamaliel Samuel (Principal)",
        totalTime: "Head of School & Senior Administrator",
      },
    ],
  },
  {
    id: 5,
    icon: "fas fa-atom",
    coursesName: "Senior Secondary — Science Track (SS 1 – 3)",
    stage: "Senior STEM Honors Track",
    targetAge: "Ages 14 – 17 Years",
    summary: "Intensive science education in Physics, Chemistry, Biology, Agriculture, and Geography for future engineers, medical professionals, and researchers.",
    highlights: [
      "WAEC, NECO & JAMB UTME high-score coaching",
      "Scientific methodology & analytical problem solving",
      "Strong foundation for STEM university admissions",
    ],
    leader: "Blessing Dukun (HOD Science) & Anawo Daniel (V.P Academics)",
    distinctive: "STEM Excellence Honors",
    courTeacher: [
      {
        dcover: "./images/team/t8.webp",
        name: "Blessing Dukun (HOD Science)",
        totalTime: "Faculty Head of Science",
      },
    ],
  },
  {
    id: 6,
    icon: "fas fa-balance-scale",
    coursesName: "Senior Secondary — Arts & Commercial (SS 1 – 3)",
    stage: "Humanities & Business Specialization",
    targetAge: "Ages 14 – 17 Years",
    summary: "Comprehensive academic training in Government, Economics, Accounting, Commerce, and Literature in English for careers in Law, Finance, and Public Administration.",
    highlights: [
      "Double-entry accounting, commercial trade & finance",
      "Nigerian constitutional history, governance & debate",
      "Advanced literary critique & African/world literature",
    ],
    leader: "John Christiana (HOD Arts) & Tangai Gamaliel Samuel (Principal)",
    distinctive: "Law & Business Leadership",
    courTeacher: [
      {
        dcover: "./images/team/t7.webp",
        name: "John Christiana (HOD Arts)",
        totalTime: "Faculty Head of Arts & Commercial",
      },
    ],
  },
]

export const curriculumData = {
  junior: {
    title: "Junior Secondary School (JSS 1 – 3)",
    description: "Approved curriculum preparing junior scholars for the Basic Education Certificate Examination (BECE).",
    subjects: [
      { name: "English Studies", desc: "Comprehension, grammar, lexis, creative writing, oral phonetics, and literature.", icon: "./images/courses/online/o2.png" },
      { name: "Mathematics", desc: "Number sense, algebra, geometry, mensuration, everyday business arithmetic, and statistics.", icon: "./images/courses/online/o1.png" },
      { name: "Intermediate Science", desc: "Foundational scientific principles, living systems, physical phenomena, energy, and environmental awareness.", icon: "./images/courses/online/o4.png" },
      { name: "Digital Studies", desc: "Computer literacy, keyboarding skills, basic software operations, typing speed, and digital safety.", icon: "./images/courses/online/o3.png" },
      { name: "Social and Citizenship Education", desc: "Civic duties, democratic governance, national unity, social awareness, and ethical citizenship.", icon: "./images/courses/online/o6.png" },
      { name: "Business Studies", desc: "Commerce fundamentals, basic accounting records, clerical office practice, and entrepreneurial mindset.", icon: "./images/courses/online/o7.png" },
      { name: "Agriculture", desc: "Crop cultivation, soil management, domestic animal husbandry, and agricultural preservation techniques.", icon: "./images/courses/online/o5.png" },
      { name: "Home Economics", desc: "Food preparation, family nutrition, fabric construction, garment care, and domestic management.", icon: "./images/courses/online/o12.png" },
      { name: "CCA (Cultural & Creative Arts)", desc: "Drawing, visual arts, music, traditional craft making, theatre performance, and folklore.", icon: "./images/courses/online/o10.png" },
      { name: "CRS (Christian Religious Studies)", desc: "Biblical teachings, Christian moral values, social ethics, forgiveness, and integrity.", icon: "./images/courses/online/o9.png" },
      { name: "PHE (Physical & Health Education)", desc: "Athletics, sports rules, physical fitness, personal health habits, and first aid principles.", icon: "./images/courses/online/o11.png" },
    ],
  },
  seniorScience: {
    title: "Senior Secondary — Science Department (SS 1 – 3)",
    description: "Rigorous science track preparing scholars for WAEC, NECO, and university STEM disciplines.",
    subjects: [
      { name: "English Language (General Core)", desc: "Formal discourse, advanced summary writing, comprehension, and oral English communication.", icon: "./images/courses/online/o2.png" },
      { name: "General Mathematics (General Core)", desc: "Trigonometry, quadratic functions, coordinate geometry, calculus, and probability.", icon: "./images/courses/online/o1.png" },
      { name: "Citizenship and Heritage Education (General Core)", desc: "National constitutional history, cultural preservation, patriotic ethics, and civic responsibility.", icon: "./images/courses/online/o6.png" },
      { name: "Digital Technologies (General Core)", desc: "Data processing, software applications, computer systems, information workflows, and digital productivity.", icon: "./images/courses/online/o3.png" },
      { name: "Physics", desc: "Mechanics, heat, optics, electricity, magnetism, waves, and practical application of physical laws.", icon: "./images/courses/online/o8.png" },
      { name: "Chemistry", desc: "Atomic theory, chemical bonding, periodic properties, organic chemistry, stoichiometry, and industrial processes.", icon: "./images/courses/online/o8.png" },
      { name: "Biology", desc: "Cellular structures, genetics, human anatomy, ecology, microbiology, and plant physiology.", icon: "./images/courses/online/o4.png" },
      { name: "Agriculture", desc: "Agronomy, animal production, soil fertility, farm surveying, agricultural economics, and extension services.", icon: "./images/courses/online/o5.png" },
      { name: "Geography", desc: "Physical earth landforms, weather systems, map interpretation, settlement geography, and global resources.", icon: "./images/courses/online/o7.png" },
    ],
  },
  seniorSocial: {
    title: "Senior Secondary — Social Science & Commercial Department (SS 1 – 3)",
    description: "Curriculum preparing scholars for careers in law, business, finance, public administration, and social sciences.",
    subjects: [
      { name: "English Language (General Core)", desc: "Formal discourse, advanced summary writing, comprehension, and oral English communication.", icon: "./images/courses/online/o2.png" },
      { name: "General Mathematics (General Core)", desc: "Applied business math, statistics, algebraic modeling, and financial calculations.", icon: "./images/courses/online/o1.png" },
      { name: "Citizenship and Heritage Education (General Core)", desc: "National constitutional history, cultural preservation, patriotic ethics, and civic responsibility.", icon: "./images/courses/online/o6.png" },
      { name: "Digital Technologies (General Core)", desc: "Data processing, office computing, digital record-keeping, and business communication software.", icon: "./images/courses/online/o3.png" },
      { name: "Economics", desc: "Price determination, national income, fiscal policy, monetary systems, international trade, and development economics.", icon: "./images/courses/online/o7.png" },
      { name: "Government", desc: "Political theories, Nigerian constitutional developments, organs of governance, and international organizations.", icon: "./images/courses/online/o9.png" },
      { name: "Accounting", desc: "Principles of double entry, ledger posting, trial balances, trading accounts, and financial statement analysis.", icon: "./images/courses/online/o1.png" },
      { name: "Commerce", desc: "Commercial trade, commercial banking, business insurance, advertising, transportation, and international exchange.", icon: "./images/courses/online/o7.png" },
      { name: "Literature", desc: "Critical literary analysis of African and non-African prose, drama, poetry, and classical themes.", icon: "./images/courses/online/o2.png" },
      { name: "CRS (Christian Religious Studies)", desc: "Advanced biblical studies, moral philosophy, Christian ethics, and social justice.", icon: "./images/courses/online/o9.png" },
      { name: "Geography", desc: "Human population studies, trade routes, economic geography, climate patterns, and cartography.", icon: "./images/courses/online/o6.png" },
    ],
  },
  primary: {
    title: "Primary School Classes (Basic 1 – 5)",
    description: "Approved curriculum building solid numeracy, quantitative mastery, literacy, scientific inquiry, moral values, and creative expression.",
    subjects: [
      { name: "Maths/Quantitative", desc: "Arithmetic operations, mental math, quantitative reasoning, geometric shapes, and word problems.", icon: "./images/courses/online/o1.png" },
      { name: "English/ Verbal", desc: "Guided reading, phonics, grammar, verbal reasoning, comprehension, and expressive composition.", icon: "./images/courses/online/o2.png" },
      { name: "Basic Science", desc: "Scientific inquiry, living things, materials, earth and space, simple machines, and environmental awareness.", icon: "./images/courses/online/o4.png" },
      { name: "Agric Science", desc: "Garden cultivation, plant anatomy, domestic animals, soil management, and simple agricultural tools.", icon: "./images/courses/online/o5.png" },
      { name: "CRS", desc: "Biblical narratives, Christian moral values, truthfulness, obedience, and loving service to others.", icon: "./images/courses/online/o9.png" },
      { name: "Creative Art", desc: "Drawing, visual arts, color theory, local crafts, clay modeling, pattern making, and artistic imagination.", icon: "./images/courses/online/o10.png" },
      { name: "PHE", desc: "Athletics, fitness drills, team sports, physical coordination, playground safety, and personal health habits.", icon: "./images/courses/online/o11.png" },
      { name: "Computer", desc: "Computer hardware identification, typing skills, digital productivity, mouse navigation, and safe digital habits.", icon: "./images/courses/online/o3.png" },
      { name: "Handwriting", desc: "Letter formation, fine motor control, cursive joining, line spacing, and neat presentation penmanship.", icon: "./images/courses/online/o2.png" },
      { name: "Civic Education", desc: "Democratic values, national symbols, civic duties, rights and responsibilities, integrity, and good citizenship.", icon: "./images/courses/online/o6.png" },
      { name: "Social Studies", desc: "Family structures, community living, Nigerian cultural heritage, safety rules, and social responsibilities.", icon: "./images/courses/online/o6.png" },
    ],
  },
  nursery: {
    title: "Nursery School Classes (Early Years)",
    description: "Early childhood development nurturing early literacy, numeracy, discovery, social habits, fine motor coordination, and sensory exploration.",
    subjects: [
      { name: "Numeracy / Quantitative", desc: "Number recognition, object counting (1–50), quantitative patterns, basic shapes, sizes, and concrete number concepts.", icon: "./images/courses/online/o1.png" },
      { name: "Literacy / Verbal", desc: "Phonics letter sounds, alphabet recognition, picture reading, oral expression, verbal reasoning, nursery rhymes, and vocabulary.", icon: "./images/courses/online/o2.png" },
      { name: "Basic Science Discovery", desc: "Foundational nature discovery, living systems, physical phenomena, and sensory exploration.", icon: "./images/courses/online/o4.png" },
      { name: "Handwriting", desc: "Pencil grip mastery, stroke tracing, pre-writing curves, and forming letters neatly within guidelines.", icon: "./images/courses/online/o2.png" },
      { name: "Colouring & Creative Art", desc: "Color identification, staying within lines, crayon coordination, and creative visual expression.", icon: "./images/courses/online/o10.png" },
      { name: "C.R.S", desc: "Simple Bible stories, praise songs, God's love, kindness, sharing, and godly character formation.", icon: "./images/courses/online/o9.png" },
      { name: "Social Habit", desc: "Courteous greetings, polite manners, sharing toys, obeying instructions, classroom etiquette, and kindness.", icon: "./images/courses/online/o6.png" },
      { name: "Health Habit", desc: "Hand washing routines, tooth care, clean uniform habits, toilet etiquette, and eating healthy fruit snacks.", icon: "./images/courses/online/o11.png" },
    ],
  },
}

export const online = [
  // JUNIOR SECONDARY CLASS (JSS 1–3)
  {
    courseName: "English",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Comprehension, expressive grammar, vocabulary development, oral communication, and creative composition.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Mathematics",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Arithmetic, algebraic processes, geometry, mensuration, everyday business calculations, and statistics.",
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
  },
  {
    courseName: "Intermediate Science",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Core scientific principles, living systems, physical phenomena, energy transformations, and environmental awareness.",
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
  },
  {
    courseName: "Digital Studies",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Computer operations, keyboarding speed, word processing, basic coding logic, digital safety, and internet ethics.",
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
  },
  {
    courseName: "Social and Citizenship Education",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Civic rights and duties, democratic values, Nigerian constitution, cultural heritage, and national unity.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },
  {
    courseName: "Business Studies",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Commerce fundamentals, basic accounting records, clerical office procedures, and entrepreneurial mindset.",
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
  },
  {
    courseName: "Agriculture",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Soil management, crop production, domestic animal husbandry, agricultural farm tools, and food preservation.",
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
  },
  {
    courseName: "Home Economics",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Food preparation, family nutrition, fabric construction, garment care, hygiene, and domestic management.",
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
  },
  {
    courseName: "CCA (Cultural & Creative Arts)",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Fine arts, drawing, indigenous crafts, traditional dance, musical performance, and cultural appreciation.",
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
  },
  {
    courseName: "CRS (Christian Religious Studies)",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Biblical narratives, moral instruction, Christian ethics, peaceful living, and community values.",
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
  },
  {
    courseName: "PHE (Physical and Health Education)",
    course: "Junior Secondary (JSS 1–3)",
    category: "junior",
    desc: "Physical fitness, track and field athletics, team ball sports, personal health habits, and first aid principles.",
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
  },

  // SENIOR SECONDARY — GENERAL CORE
  {
    courseName: "English",
    course: "Senior Secondary (General Core)",
    category: "senior-core",
    desc: "Advanced essay writing, comprehension, lexis and structure, and oral diction for WAEC and NECO distinction.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Mathematics",
    course: "Senior Secondary (General Core)",
    category: "senior-core",
    desc: "Algebraic functions, coordinate geometry, trigonometry, calculus foundations, statistics, and probability.",
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
  },
  {
    courseName: "Citizenship and Heritage Education",
    course: "Senior Secondary (General Core)",
    category: "senior-core",
    desc: "National constitutional history, cultural preservation, patriotic ethics, civic responsibility, and peace building.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },
  {
    courseName: "Digital technologies",
    course: "Senior Secondary (General Core)",
    category: "senior-core",
    desc: "Data processing, spreadsheet modeling, presentation software, computing systems, and digital productivity workflows.",
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
  },

  // SENIOR SECONDARY — SCIENCE CLASS
  {
    courseName: "Biology",
    course: "Senior Secondary (Science Track)",
    category: "senior-science",
    desc: "Cell biology, plant and animal physiology, genetics, ecology, disease prevention, and biodiversity.",
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
  },
  {
    courseName: "Chemistry",
    course: "Senior Secondary (Science Track)",
    category: "senior-science",
    desc: "Atomic theory, chemical bonding, periodic table trends, organic chemistry, reaction stoichiometry, and industrial applications.",
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
  },
  {
    courseName: "Physics",
    course: "Senior Secondary (Science Track)",
    category: "senior-science",
    desc: "Mechanics, kinematics, wave motion, electricity, electromagnetism, thermal physics, and optics.",
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
  },
  {
    courseName: "Agriculture",
    course: "Senior Secondary (Science Track)",
    category: "senior-science",
    desc: "Agronomy, soil science, farm surveying, animal husbandry, agricultural economics, and agribusiness management.",
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
  },
  {
    courseName: "Geography",
    course: "Senior Secondary (Science Track)",
    category: "senior-science",
    desc: "Physical earth landforms, weather systems, climatology, map reading, and environmental resource distribution.",
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
  },

  // SENIOR SECONDARY — SOCIAL SCIENCE & COMMERCIAL CLASS
  {
    courseName: "Government",
    course: "Senior Secondary (Social Science Track)",
    category: "senior-social",
    desc: "Political theory, Nigerian constitutional development, public administration, international relations, and civic institutions.",
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
  },
  {
    courseName: "Economics",
    course: "Senior Secondary (Social Science Track)",
    category: "senior-social",
    desc: "Price theory, national accounts, fiscal and monetary policies, international trade, and economic development strategies.",
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
  },
  {
    courseName: "CRS (Christian Religious Studies)",
    course: "Senior Secondary (Social Science Track)",
    category: "senior-social",
    desc: "Advanced biblical studies, Christian ethics, moral leadership, justice, and social responsibility in community life.",
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
  },
  {
    courseName: "Literature",
    course: "Senior Secondary (Arts & Humanities Track)",
    category: "senior-social",
    desc: "Analytical study of African and non-African drama, prose fiction, poetic devices, and literary critique.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Accounting",
    course: "Senior Secondary (Commercial Track)",
    category: "senior-social",
    desc: "Principles of double-entry book-keeping, ledger posting, cashbooks, trial balances, and financial statement analysis.",
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
  },
  {
    courseName: "Commerce",
    course: "Senior Secondary (Commercial Track)",
    category: "senior-social",
    desc: "Trade mechanisms, commercial banking, business law, marketing, transport logistics, and capital markets.",
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
  },
  {
    courseName: "Geography",
    course: "Senior Secondary (Social Science Track)",
    category: "senior-social",
    desc: "Human settlement geography, economic networks, demographic patterns, regional trade, and urban planning.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },

  // PRIMARY CLASSES (BASIC 1–5 SECTION)
  {
    courseName: "Maths/Quantitative",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Arithmetic operations, mental calculations, quantitative aptitude, geometric shapes, fractions, and logical deduction.",
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
  },
  {
    courseName: "English/ Verbal",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Guided reading, phonics, grammar, verbal reasoning, comprehension, vocabulary development, and expressive composition.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Basic Science",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Scientific inquiry, living systems, earth and environment, simple machines, energy transformations, and observation skills.",
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
  },
  {
    courseName: "Agric Science",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Garden cultivation, plant anatomy, domestic animals, soil management, simple farm tools, and crop caring.",
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
  },
  {
    courseName: "CRS",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Biblical narratives, Christian moral values, truthfulness, obedience, character molding, and loving service.",
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
  },
  {
    courseName: "Creative Art",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Drawing, visual arts, color theory, local crafts, clay modeling, pattern making, and artistic imagination.",
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
  },
  {
    courseName: "PHE",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Athletics, fitness drills, team sports, physical coordination, playground safety, and personal health habits.",
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
  },
  {
    courseName: "Computer",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Computer hardware identification, typing skills, digital productivity, mouse navigation, and safe digital citizenship.",
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
  },
  {
    courseName: "Handwriting",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Letter formation, fine motor control, cursive joining, line spacing, and neat presentation penmanship.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Civic Education",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Democratic values, national symbols, civic duties, rights and responsibilities, integrity, and good citizenship.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },
  {
    courseName: "Social Studies",
    course: "Primary School (Basic 1–5)",
    category: "primary",
    desc: "Family structures, community living, Nigerian cultural heritage, safety rules, and social responsibilities.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },

  // NURSERY CLASSES (EARLY YEARS SECTION)
  {
    courseName: "Numeracy / Quantitative",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Number recognition, object counting (1–50), quantitative reasoning, identification of basic shapes, sizes, and concrete number concepts.",
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
  },
  {
    courseName: "Literacy / Verbal",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Phonics letter sounds, alphabet recognition, picture reading, verbal reasoning, oral expression, nursery rhymes, and vocabulary.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Handwriting",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Pencil grip mastery, stroke tracing, pre-writing curves, and forming letters neatly within guidelines.",
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
  },
  {
    courseName: "Colouring",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Color identification, staying within lines, crayon coordination, and creative visual expression.",
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
  },
  {
    courseName: "Creative Art",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Playdough modeling, finger painting, paper crafts, sensory art exploration, and hands-on creativity.",
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
  },
  {
    courseName: "C.R.S",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Simple Bible stories, praise songs, God's love, kindness, sharing, and godly character formation.",
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
  },
  {
    courseName: "Social Habit",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Courteous greetings, polite manners, sharing toys, obeying instructions, classroom etiquette, and kindness.",
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
  },
  {
    courseName: "Health Habit",
    course: "Nursery School (Early Years)",
    category: "nursery",
    desc: "Hand washing routines, tooth care, clean uniform habits, toilet etiquette, and eating healthy fruit snacks.",
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
  },
]

export const team = [
  {
    cover: "./images/team/gambo.png",
    name: "Rev. Fidelis Gambo",
    work: "PROPRIETOR & FOUNDER (POLICE CHAPLAIN & FORMER UNIV. LECTURER)",
    role: "Proprietor & Founder",
    bio: "Founding visionary with an illustrious background in education, university lecturing, ministry, and public service.",
    badge: "PROPRIETOR & FOUNDER",
    facebook: "https://web.facebook.com/fidelis.gambo.98",
  },
  {
    cover: "./images/team/sifon.jpeg",
    name: "Mrs. Sifon Gambo",
    work: "PROPRIETRESS & CO-FOUNDER",
    role: "Proprietress & Co-Founder",
    bio: "A dedicated educator, Mrs. Gambo, also the wife of Reverend Gambo, serves as proprietress — bringing compassion, discipline, and a motherly touch to the school and mission work.",
    badge: "PROPRIETRESS & CO-FOUNDER",
    facebook: "https://web.facebook.com/sifon.gambo.7",
  },
  {
    cover: "./images/team/gamaliel.jpeg",
    name: "Tangai Gamaliel Samuel",
    work: "PRINCIPAL",
    role: "Head of School & Chief Administrator",
    bio: "Guiding institutional discipline, secondary education delivery, and outstanding success in WAEC, NECO, and BECE examinations.",
    badge: "LEADERSHIP TEAM",
    facebook: "https://web.facebook.com/profile.php?id=61587944463675",
  },
  {
    cover: "",
    name: "Alheri Maga",
    work: "V.P ADMIN & HEAD TEACHER",
    role: "Vice Principal (Admin) & Head Teacher",
    bio: "Leading overall school administration, foundational basic education standards, and early childhood care excellence.",
  },
  {
    cover: "./images/team/Daniel.jpeg",
    name: "Anawo Daniel",
    work: "V.P ACADEMICS",
    role: "Vice Principal (Academics) & Dean of Studies",
    bio: "Directing NERDC curriculum delivery, continuous assessment protocols, and high academic honors across all learning stages.",
    facebook: "https://web.facebook.com/anawo.daniel",
  },
  {
    cover: "./images/team/Shut Esther.jpeg",
    name: "Shut Esther",
    work: "ASSISTANT HM",
    role: "Assistant Head Mistress",
    bio: "Championing foundational literacy, Jolly Phonics instruction, and nurturing child-centered pastoral care.",
  },
  {
    cover: "",
    name: "John Christiana",
    work: "HOD ARTS",
    role: "Head of Department (Arts & Social Sciences)",
    bio: "Directing academic excellence in Government, Literature, Economics, Accounting, Commerce, and Christian Religious Studies.",
  },
  {
    cover: "",
    name: "Blessing Dukun",
    work: "HOD SCIENCE",
    role: "Head of Department (Sciences)",
    bio: "Overseeing rigorous scientific inquiry, mathematical accuracy, and STEM distinction in Physics, Chemistry, Biology, and Agriculture.",
  },
]

export const price = [
  {
    name: "CRÈCHE DIVISION",
    division: "Infants & Toddlers",
    age: "3 months – 2 years",
    badge: "Early Childhood Care",
    desc: "A warm, hygienic, and secure learning haven tailored for early sensory discovery, motor development, and loving pastoral care.",
    highlights: [
      "Sensory & Gross Motor Play Discovery",
      "Nutritious snack schedule & nap routine",
      "Dedicated caregivers & first-aid trained attendants",
      "Section A & Section B fee schedule available on request",
    ],
    req: "2 rolls of tissue paper & 1 medium-size detergent",
    curriculum: "Early Childhood Montessori & Sensory Discovery",
  },
  {
    name: "NURSERY ONE & TWO",
    division: "Early Learning Division",
    age: "3 – 5 years",
    badge: "Foundational Phonics",
    desc: "Empowering young minds with early Jolly Phonics literacy, numeracy foundation, moral values, and creative discovery.",
    highlights: [
      "Jolly Phonics, Early Reading & Pre-Writing",
      "Foundational Numeracy & Quantitative Concepts",
      "Social habits, health etiquette & creative arts",
      "Itemized Section A & B prospectus guide available on request",
    ],
    req: "2 rolls of tissue paper & 1 medium-size detergent",
    curriculum: "NERDC Early Childhood & Jolly Phonics Syllabi",
  },
  {
    name: "PRIMARY ONE – FIVE",
    division: "Basic Education Division",
    age: "6 – 10 years",
    badge: "Basic Academic Distinction",
    desc: "Rigorous core primary curriculum building formidable numeracy, literacy, basic sciences, ICT digital literacy, and godly character.",
    highlights: [
      "Mathematics, English Grammar & Verbal Reasoning",
      "Basic Science, Practical Agriculture & Computer Studies",
      "CRS Christian Ethics & Civic Leadership",
      "Section A (Tuition/Levies) & Section B (Uniforms/Books) on request",
    ],
    req: "2 rolls of tissue paper & 1 medium-size detergent",
    curriculum: "National Basic Education (NERDC) Primary Standard",
  },
  {
    name: "SECONDARY – JUNIOR (JSS 1–3)",
    division: "Junior High Division",
    age: "11 – 13 years",
    badge: "BECE Distinction Prep",
    desc: "Solid transition into secondary education with intermediate sciences, humanities, French, business studies, and BECE examination distinction.",
    highlights: [
      "Integrated Basic Science, Technology & Computer Lab",
      "Business Studies, Social Studies & French Language",
      "Intensive Basic Education Certificate Examination (BECE) Prep",
      "Full Section A & B itemized breakdown provided upon request",
    ],
    req: "1 big mop stick or 1 big hoe or 2 big bunches of brooms",
    curriculum: "Junior Secondary NERDC & BECE Examination Benchmark",
  },
  {
    name: "SECONDARY – SENIOR (SS 1–3)",
    division: "Senior Secondary Division",
    age: "14 – 17 years",
    badge: "WAEC • NECO • JAMB Excellence",
    desc: "Comprehensive Senior Secondary preparation across Science, Arts & Commercial departments with proven distinction in WAEC, NECO & JAMB UTME.",
    highlights: [
      "Science, Commercial & Arts specialized departments",
      "Physics, Chemistry, Biology & Agriculture Laboratories",
      "WAEC, NECO & UTME mock testing and extension coaching",
      "Complete Section A & B prospectus schedule provided upon request",
    ],
    req: "1 big mop stick or 1 big hoe or 2 big bunches of brooms",
    curriculum: "Senior Secondary NERDC, WAEC & NECO Syllabi",
  },
]

export const faq = [
  {
    title: "What are the school's official account details for fee payment?",
    desc: "All payments must be made to the official school bank account: Bank: First Bank | Account Name: Brighter Land International School | Account Number: 2043561832. Always obtain or present your bank deposit slip / electronic transfer receipt to the Bursar for official verification and receipt issuance.",
  },
  {
    title: "What is included in Section A (Tuition & School Levies)?",
    desc: "Section A is payable directly to the school each term and covers: Tuition Fees, PTA Levy, School Development Levy, Terminal Examination Fee, School First Aid Clinic Fee, and Compulsory Lesson Coaching. Detailed itemized fee schedules for each division are available upon request via our Admissions Secretariat.",
  },
  {
    title: "What is included in Section B (Uniforms & Learning Materials)?",
    desc: "Section B covers essential student learning materials and customized attire: Official School Uniforms (2 sets for secondary), School Sweaters, Wednesday Wear, Sportswear, and class-specific Textbooks/Workbooks tailored to the NERDC national curriculum.",
  },
  {
    title: "How do I request the official school prospectus and fee breakdown?",
    desc: "Prospective parents can submit a quick Prospectus Request through our website form, or contact the Admissions Desk directly at +234 803 436 7951 / brighterlandschool2022@gmail.com to have the approved prospectus PDF and fee schedules sent directly to their email.",
  },
  {
    title: "What are the additional term requirements for enrolled scholars?",
    desc: "For Crèche, Nursery 1-2, and Primary 1-5: 2 rolls of tissue paper and 1 medium-size detergent. For Secondary School (JSS 1-3 & SS 1-3): 1 big mop stick OR 1 big hoe OR 2 big bunches of brooms.",
  },
  {
    title: "How does the BLIS Operations Portal assist parents in tracking fees and report cards?",
    desc: "Parents can log into the BLIS Portal 24/7 to inspect fee balances, download official Bursar payment receipts with verification stamps, view student daily roll-call attendance, and generate official Terminal Academic Progress Reports.",
  },
  {
    title: "How do after-school academic lessons operate at Brighter Land?",
    desc: "A structured compulsory lesson coaching session is integrated into the academic afternoon routine. Subject teachers provide focused academic coaching, homework assistance, quantitative reasoning, and examination reinforcement for every student.",
  },
]

export const blog = []

export const testimonal = []

// Real-Time School Operations & Management Datasets (Clean Initial State - Dynamic Management)
export const initialStudents = []

export const initialGradebook = []

export const initialInvoices = []

export const admissionsPipeline = []


export const generateDefaultTimetable = (className) => {
  const isSenior = className.toLowerCase().startsWith("ss")
  const isPrimary = className.toLowerCase().startsWith("primary") || className.toLowerCase().startsWith("basic")
  const isNursery = className.toLowerCase().startsWith("nursery") || className.toLowerCase().includes("crèche") || className.toLowerCase().includes("creche")

  if (isSenior) {
    return [
      { period: "Period 1 (08:00 - 08:45)", mon: "General Mathematics", tue: "English Language", wed: "Physics / Economics", thu: "Chemistry / Accounting", fri: "General Mathematics" },
      { period: "Period 2 (08:45 - 09:30)", mon: "English Language", tue: "General Mathematics", wed: "Biology / Commerce", thu: "Agricultural Science", fri: "English Language" },
      { period: "Period 3 (09:30 - 10:15)", mon: "Physics / Economics", tue: "Chemistry / Government", wed: "Civic Education", thu: "Geography / CRS", fri: "Technical Drawing / Literature" },
      { period: "Breakfast Break (10:15 - 10:45)", mon: "Recess Break", tue: "Recess Break", wed: "Recess Break", thu: "Recess Break", fri: "Assembly & Recess" },
      { period: "Period 4 (10:45 - 11:30)", mon: "Chemistry / Accounting", tue: "Biology / Commerce", wed: "General Mathematics", thu: "English Language", fri: "Digital Technologies / Computer" },
      { period: "Period 5 (11:30 - 12:15)", mon: "Agricultural Science", tue: "Physics / Economics", wed: "Civic Education", thu: "Government / Further Maths", fri: "Science Practical / Lab" },
      { period: "Period 6 (12:15 - 13:00)", mon: "Further Mathematics", tue: "Christian Religious Studies (CRS)", wed: "Digital Technologies / Computer", thu: "General Mathematics", fri: "WAEC Preparation Seminar" },
      { period: "Lunch Break (13:00 - 13:40)", mon: "Lunch Recess", tue: "Lunch Recess", wed: "Lunch Recess", thu: "Lunch Recess", fri: "Lunch Recess" },
      { period: "Lesson Period (13:40 - 14:40)", mon: "Senior Extension Coaching", tue: "Compulsory Lesson", wed: "Compulsory Lesson", thu: "Compulsory Lesson", fri: "Closing Assembly" },
    ]
  }

  if (isPrimary) {
    return [
      { period: "Period 1 (08:00 - 08:45)", mon: "Mathematics / Quantitative", tue: "English Studies / Verbal", wed: "Basic Science & Technology", thu: "Social Studies", fri: "Mathematics / Quantitative" },
      { period: "Period 2 (08:45 - 09:30)", mon: "English Studies / Verbal", tue: "Mathematics / Quantitative", wed: "Computer Studies", thu: "Agricultural Science", fri: "English Studies / Verbal" },
      { period: "Period 3 (09:30 - 10:15)", mon: "Basic Science & Technology", tue: "Civic Education", wed: "Christian Religious Studies (CRS)", thu: "Handwriting", fri: "Social Studies" },
      { period: "Breakfast Break (10:15 - 10:45)", mon: "Play & Snack Break", tue: "Play & Snack Break", wed: "Play & Snack Break", thu: "Play & Snack Break", fri: "Assembly & Recess" },
      { period: "Period 4 (10:45 - 11:30)", mon: "Agricultural Science", tue: "Cultural & Creative Arts (CCA)", wed: "Mathematics / Quantitative", thu: "English Studies / Verbal", fri: "Physical & Health Education (PHE)" },
      { period: "Period 5 (11:30 - 12:15)", mon: "Computer Studies", tue: "Social Studies", wed: "Handwriting", thu: "Cultural & Creative Arts (CCA)", fri: "Spelling Bee & Storytelling" },
      { period: "Period 6 (12:15 - 13:00)", mon: "Civic Education", tue: "Christian Religious Studies (CRS)", wed: "Basic Science & Technology", thu: "Mathematics / Quantitative", fri: "Clubs & Activities" },
      { period: "Lunch Break (13:00 - 13:40)", mon: "Lunch Recess", tue: "Lunch Recess", wed: "Lunch Recess", thu: "Lunch Recess", fri: "Lunch Recess" },
      { period: "Lesson Period (13:40 - 14:40)", mon: "Afternoon Prep & Reading", tue: "Compulsory Lesson", wed: "Compulsory Lesson", thu: "Compulsory Lesson", fri: "Class Dismissal & Review" },
    ]
  }

  if (isNursery) {
    return [
      { period: "Period 1 (08:00 - 08:45)", mon: "Numeracy / Quantitative", tue: "Literacy / Verbal", wed: "Numeracy / Quantitative", thu: "Literacy / Verbal", fri: "Numeracy / Quantitative" },
      { period: "Period 2 (08:45 - 09:30)", mon: "Literacy / Verbal", tue: "Numeracy / Quantitative", wed: "Basic Science Discovery", thu: "Social Habits", fri: "Literacy / Verbal" },
      { period: "Period 3 (09:30 - 10:15)", mon: "Handwriting & Tracing", tue: "Colouring & Creative Art", wed: "Christian Religious Studies (CRS)", thu: "Health Habits", fri: "Rhymes & Singing" },
      { period: "Snack & Nap Break (10:15 - 11:00)", mon: "Snack & Rest Time", tue: "Snack & Rest Time", wed: "Snack & Rest Time", thu: "Snack & Rest Time", fri: "Snack & Rest Time" },
      { period: "Period 4 (11:00 - 11:45)", mon: "Social Habits", tue: "Health Habits", wed: "Colouring & Creative Art", thu: "Numeracy / Quantitative", fri: "Playground & Gross Motor" },
      { period: "Period 5 (11:45 - 12:30)", mon: "Story Time & Flashcards", tue: "Rhymes & Alphabet Play", wed: "Basic Science Discovery", thu: "Handwriting & Tracing", fri: "Closing Circle & Dismissal" },
    ]
  }

  // Default Junior Secondary (JSS 1 – JSS 3)
  return [
    { period: "Period 1 (08:00 - 08:45)", mon: "Mathematics", tue: "English Studies", wed: "Basic Science", thu: "Social Studies", fri: "Mathematics" },
    { period: "Period 2 (08:45 - 09:30)", mon: "English Studies", tue: "Mathematics", wed: "Computer Studies", thu: "Agricultural Science", fri: "English Studies" },
    { period: "Period 3 (09:30 - 10:15)", mon: "Basic Science", tue: "Computer Studies", wed: "Business Studies", thu: "CRS", fri: "Social Studies" },
    { period: "Breakfast Break (10:15 - 10:45)", mon: "Recess Break", tue: "Recess Break", wed: "Recess Break", thu: "Recess Break", fri: "Assembly & Recess" },
    { period: "Period 4 (10:45 - 11:30)", mon: "Agricultural Science", tue: "Civic Education", wed: "Mathematics", thu: "English Studies", fri: "Physical & Health Education (PHE)" },
    { period: "Period 5 (11:30 - 12:15)", mon: "Business Studies", tue: "Basic Science", wed: "Home Economics", thu: "Cultural & Creative Arts (CCA)", fri: "French Language" },
    { period: "Period 6 (12:15 - 13:00)", mon: "Christian Religious Studies (CRS)", tue: "Cultural & Creative Arts (CCA)", wed: "French Language", thu: "Mathematics", fri: "Co-Curricular Clubs" },
    { period: "Lunch Break (13:00 - 13:40)", mon: "Lunch Recess", tue: "Lunch Recess", wed: "Lunch Recess", thu: "Lunch Recess", fri: "Lunch Recess" },
    { period: "Lesson Period (13:40 - 14:40)", mon: "Afternoon Prep / Lesson", tue: "Compulsory Lesson", wed: "Compulsory Lesson", thu: "Compulsory Lesson", fri: "Closing & Class Review" },
  ]
}

export const schoolTimetable = {
  "JSS 1": generateDefaultTimetable("JSS 1"),
  "JSS 2": [
    { period: "Period 1 (08:00 - 08:45)", mon: "Mathematics", tue: "English", wed: "Intermediate Science", thu: "Digital Studies", fri: "Mathematics" },
    { period: "Period 2 (08:45 - 09:30)", mon: "English", tue: "Mathematics", wed: "Social and Citizenship Education", thu: "Agriculture", fri: "English" },
    { period: "Period 3 (09:30 - 10:15)", mon: "Intermediate Science", tue: "Digital Studies", wed: "Business Studies", thu: "CRS", fri: "Social and Citizenship Education" },
    { period: "Breakfast Break (10:15 - 10:45)", mon: "Recess Break", tue: "Recess Break", wed: "Recess Break", thu: "Recess Break", fri: "Assembly & Recess" },
    { period: "Period 4 (10:45 - 11:30)", mon: "Agriculture", tue: "Social and Citizenship Education", wed: "Mathematics", thu: "English", fri: "PHE" },
    { period: "Period 5 (11:30 - 12:15)", mon: "Agriculture", tue: "Intermediate Science", wed: "Digital Studies", thu: "CCA", fri: "Co-Curricular Clubs" },
    { period: "Period 6 (12:15 - 13:00)", mon: "Business Studies", tue: "CRS", wed: "Home Economics", thu: "Mathematics", fri: "Debate & Diction" },
    { period: "Lunch Break (13:00 - 13:40)", mon: "Lunch Recess", tue: "Lunch Recess", wed: "Lunch Recess", thu: "Lunch Recess", fri: "Lunch Recess" },
    { period: "Lesson Period (13:40 - 14:40)", mon: "Compulsory Lesson", tue: "Compulsory Lesson", wed: "Compulsory Lesson", thu: "Compulsory Lesson", fri: "Closing & Review" },
  ],
  "JSS 3": generateDefaultTimetable("JSS 3"),
  "SS 1": generateDefaultTimetable("SS 1"),
  "SS 2": generateDefaultTimetable("SS 2"),
  "SS 3": generateDefaultTimetable("SS 3"),
  "Primary 1": generateDefaultTimetable("Primary 1"),
  "Primary 2": generateDefaultTimetable("Primary 2"),
  "Primary 3": generateDefaultTimetable("Primary 3"),
  "Primary 4": generateDefaultTimetable("Primary 4"),
  "Primary 5": generateDefaultTimetable("Primary 5"),
  "Nursery 1": generateDefaultTimetable("Nursery 1"),
  "Nursery 2": generateDefaultTimetable("Nursery 2"),
  "Crèche": generateDefaultTimetable("Crèche"),
}

export const announcements = []

export const schoolCampuses = [
  {
    id: "headquarters",
    name: "Headquarters (Main Campus)",
    shortCode: "HQ",
    badgeColor: "#00a884",
    address: "Gura-Suga, Opposite Police Staff College, Jos, Plateau State, Nigeria",
    lead: "Rev. Fidelis Gambo (Proprietor), Mrs. Sifon Gambo (Proprietress) & Mr. Tangai Samuel (Principal)",
    phone: "+234 803 436 7951",
    email: "hq@brighterland.sch.ng",
    levels: ["Crèche", "Nursery 1 & 2", "Primary 1 - 5", "JSS 1 - 3", "SS 1 - 3"],
    capacity: 350,
    established: "2022",
    features: "Main Administrative Complex, Science Laboratory, ICT Centre, Central Library & Sports Field",
  },
  {
    id: "annex",
    name: "Annex Campus",
    shortCode: "Annex",
    badgeColor: "#2563eb",
    address: "Rayfield / Zawan Road Annex Campus, Jos, Plateau State, Nigeria",
    lead: "Mrs. Alheri Maga (VP Admin / Head Mistress)",
    phone: "+234 802 123 4567",
    email: "annex@brighterland.sch.ng",
    levels: ["Crèche", "Nursery 1 & 2", "Primary 1 - 5", "JSS 1 - 3"],
    capacity: 200,
    established: "2024",
    features: "Early Learning Wing, Play Arena, Primary Classrooms, Junior Science & Phonics Lab",
  },
]

export const busFleet = [
  {
    route: "Route 1 - Town Center & Main Express",
    busNo: "BLIS-BUS-01",
    campus: "Headquarters",
    driver: "Mr. Sunday Okafor",
    phone: "0803 111 2233",
    capacity: "36 / 40",
    status: "On Schedule",
    currentLocation: "Roundabout Junction - Stop 3",
    etaSchool: "07:35 AM",
  },
  {
    route: "Route 2 - GRA & Residential Layout",
    busNo: "BLIS-BUS-02",
    campus: "Headquarters",
    driver: "Mr. Yakubu Musa",
    phone: "0802 333 4455",
    capacity: "38 / 40",
    status: "Completed",
    currentLocation: "School Main Gate Bay A",
    etaSchool: "Arrived",
  },
  {
    route: "Route 3 - Rayfield, Zawan & Annex Corridor",
    busNo: "BLIS-BUS-03",
    campus: "Annex",
    driver: "Mr. Samuel Adeleke",
    phone: "0805 555 6677",
    capacity: "32 / 40",
    status: "On Schedule",
    currentLocation: "Estate Gate - Stop 5",
    etaSchool: "07:42 AM",
  },
  {
    route: "Route 4 - Hilltop & New Extension",
    busNo: "BLIS-BUS-04",
    campus: "Annex",
    driver: "Mr. Gregory Nnamdi",
    phone: "0809 777 8899",
    capacity: "35 / 40",
    status: "Completed",
    currentLocation: "School Bus Bay B",
    etaSchool: "Arrived",
  },
]

export const availableSchoolClasses = [
  "Crèche",
  "Nursery 1",
  "Nursery 2",
  "Primary 1",
  "Primary 2",
  "Primary 3",
  "Primary 4",
  "Primary 5",
  "JSS 1",
  "JSS 2",
  "JSS 3",
  "SS 1",
  "SS 2",
  "SS 3",
]

export const institutionalDepartments = [
  "Executive Boardroom & Governance",
  "School Administration & Central Registry",
  "Secondary School Faculty (JSS & SSS)",
  "Primary School Faculty (Basic 1 - 5)",
  "Early Childhood & Nursery Section (Crèche, Nursery 1 - 2)",
  "Bursary & Accounts Directorate",
  "Science Laboratory & ICT Directorate",
  "Guidance, Counseling & Student Affairs",
  "Campus Logistics, Transport & Facilities",
  "Parent-Teacher Association (PTA)",
  "Academic Scholar Registry",
  "General Institutional Staff",
]

export const initialPortalUsers = [
  {
    id: "USR-ADMIN-01",
    username: "admin",
    email: "brighterlandschool2022@gmail.com",
    password: "admin",
    name: "BLIS School Administrator",
    role: "admin",
    roleTitle: "Super Administrator & Registry Secretariat",
    campus: "All Campuses",
    department: "School Administration & Central Registry",
    privileges: "Master System Administrator (Multi-Branch Telemetry, User Registry, Staff Access Control, Student Information System, Bursary & Fees, Gradebook, Class Timetables, Circulars)",
    assignedClasses: ["All Classes"],
    status: "Active",
  },
]

export const getSubjectsForClass = (className) => {
  if (!className || className === "All") {
    return [
      "Mathematics",
      "English Studies",
      "English Language",
      "Basic Science",
      "Physics",
      "Chemistry",
      "Biology",
      "Agricultural Science",
      "Economics",
      "Government",
      "Financial Accounting",
      "Commerce",
      "Literature in English",
      "Business Studies",
      "Computer Studies",
      "Digital Technologies",
      "Social Studies",
      "Civic Education",
      "Christian Religious Studies (CRS)",
      "Cultural & Creative Arts (CCA)",
      "Physical & Health Education (PHE)",
      "Geography",
      "Further Mathematics",
      "Home Economics",
      "Technical Drawing",
      "French Language",
    ]
  }
  const lower = className.toLowerCase().trim()
  if (lower.startsWith("ss") || lower.includes("senior")) {
    return [
      "General Mathematics",
      "English Language",
      "Physics",
      "Chemistry",
      "Biology",
      "Agricultural Science",
      "Economics",
      "Government",
      "Financial Accounting",
      "Commerce",
      "Literature in English",
      "Civic Education",
      "Geography",
      "Christian Religious Studies (CRS)",
      "Digital Technologies / Computer",
      "Further Mathematics",
      "Technical Drawing",
    ]
  }
  if (lower.startsWith("jss") || lower.includes("junior")) {
    return [
      "English Studies",
      "Mathematics",
      "Basic Science",
      "Social Studies",
      "Agricultural Science",
      "Business Studies",
      "Computer Studies",
      "Civic Education",
      "Christian Religious Studies (CRS)",
      "Cultural & Creative Arts (CCA)",
      "Physical & Health Education (PHE)",
      "Home Economics",
      "French Language",
    ]
  }
  if (lower.startsWith("primary") || lower.startsWith("basic")) {
    return [
      "Mathematics / Quantitative",
      "English Studies / Verbal",
      "Basic Science & Technology",
      "Agricultural Science",
      "Social Studies",
      "Civic Education",
      "Christian Religious Studies (CRS)",
      "Cultural & Creative Arts (CCA)",
      "Physical & Health Education (PHE)",
      "Computer Studies",
      "Handwriting",
    ]
  }
  if (lower.startsWith("nursery") || lower.startsWith("crèche") || lower.startsWith("creche")) {
    return [
      "Numeracy / Quantitative",
      "Literacy / Verbal",
      "Basic Science Discovery",
      "Handwriting",
      "Colouring & Creative Art",
      "Christian Religious Studies (CRS)",
      "Social Habits",
      "Health Habits",
    ]
  }
  return [
    "Mathematics",
    "English Studies",
    "Basic Science",
    "Agricultural Science",
    "Social Studies",
    "Civic Education",
    "Christian Religious Studies (CRS)",
    "Computer Studies",
  ]
}


